<template>
  <AppLayout>
    <template #sidebar>
      <Sidebar class="sidebar-container" />
    </template>
    <template #right-menu>
      <RightMenu />
    </template>
  </AppLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useAppStore } from '@/store/modules/app'
import { useUserStore } from '@/store/modules/user'

import useRouter from '@/hooks/useRouter'

import AppLayout from '@/layout/index.vue'
import RightMenu from './components/RightMenu.vue'
import { Sidebar } from '@/layout/components'

export default defineComponent({
  name: 'Layout',
  components: {
    AppLayout,
    RightMenu,
    Sidebar
  },
  setup: () => {
    const appStore = useAppStore()
    const { isRtbUser, isStaff } = useUserStore()
    const routesFilter = (routes: any[]) => {
      return routes.reduce((items: any[], route: any) => {
        let show = true
        if (route.meta) {
          if ('rtbOnly' in route.meta) {
            show = isRtbUser === route.meta.rtbOnly
          } else if ('directOnly' in route.meta) {
            show = isRtbUser !== route.meta.directOnly
          }
          if ('adminOnly' in route.meta) {
            show = isStaff === route.meta.adminOnly
          }
        }

        if (show) {
          if (route.children) {
            route.children = routesFilter(route.children)
          }
          items.push(route)
        }

        return items
      }, [])
    }

    const { router } = useRouter()
    const routes = routesFilter((router as any).options.routes)

    appStore.SetRoutes(routes)
  }
})
</script>
<style lang="scss" scoped>
:deep(.navbar) {
  height: 4rem;
  padding: 0 1.25rem;
}
:deep(.left-menu) {
  gap: 0.75rem;
}
:deep(.hamburger-container) {
  justify-content: center;
  height: 1.75rem;
  width: 1.75rem;
  padding: 0;
  border-radius: 0.375rem;
  &:hover {
    background-color: #f3f4f5;
  }
}
:deep(.el-breadcrumb__item .el-breadcrumb__inner) {
  a {
    color: #2b303b;
    &:hover {
      color: #6a7178;
    }
  }
  .no-redirect {
    color: #676f7e;
  }
}
</style>
